import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  ConsumedResource,
  OverridableCost,
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import ConsumedResourceInput from "@dndComponents/feature/ConsumedResourceInput";

interface Props {
  obj: OverridableCost;
  disabled: boolean;
  no_amount?: boolean;
  onChange: (changed: OverridableCost) => void; 
}

export default function OverridableCostInput({
  obj,
  disabled,
  no_amount = false,
  onChange, 
}: Props) {
  const [ping, setPing] = useState(false);
    
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox 
          name="Slot Override"
          disabled={disabled}
          options={["Don't Override","At Will","At Will or Slot Upcast","Only Special Resource","Or Special Resource","And Special Resource"]}
          value={obj.slot_override}
          onChange={(changed: "Don't Override" | "At Will" | "At Will or Slot Upcast" | "Only Special Resource" | "Or Special Resource" | "And Special Resource") => {
            const new_obj = obj.clone();
            new_obj.slot_override = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        /> 
      </Grid>
      { !["Don't Override","At Will","At Will or Slot Upcast"].includes(obj.slot_override) &&
        <>
          <Grid
            size={{
              xs: 12
            }}>
            <ConsumedResourceInput 
              obj={obj.consumed_resource} 
              no_amount={no_amount}
              disabled={false}
              onChange={(changed: ConsumedResource) => {
                const new_obj = obj.clone();
                new_obj.consumed_resource = changed;
                onChange(new_obj);
                setPing(!ping);
              }}
            />
          </Grid>
        </>
      }
    </Grid>
  );
}